import React, { useRef } from "react"
import { graphql } from "gatsby"
import { Layout, Seo, Nav, Section } from "../components"
import { useOnScreen } from "../utils/hooks"
import { template } from "../utils/helpers"

export default function PrivacyPolicy({ data }) {
  const { frontmatter, html } = data?.file?.childMarkdownRemark

  const COMPANY_NAME = "pushfusion"
  const COMPANY_WEBSITE = "pushfusion.io"
  const INTRO =
    "Based in the United Kingdom, Binary Forge Solutions Ltd. is a world leader in the design and development of connected solutions including the pushfusion brand."

  const ref = useRef()
  const isHeaderVisible = useOnScreen(ref)
  return (
    <Layout>
      <Seo title="Privacy Policy" />
      <div>
        <Nav isHeaderVisible={isHeaderVisible} />
        <Section>
          <div ref={ref}>
            <h1>
              <span className="mt-1 font-extrabold block">
                <span className="block text-pushfusion">
                  {frontmatter.title}
                </span>
                <span className="block text-gray-700">{COMPANY_NAME}</span>
              </span>
            </h1>
            <p className="pt-4 lg:pt-12 text-base font-medium text-gray-500 sm:mt-5 lg:text-lg xl:text-xl text-justify">
              Effective from {frontmatter.date}.
            </p>
          </div>
          <div className="mt-20 text-justify">
            <article
              className="prose prose-gray prose-lg max-w-none prose-h2:text-gray-700 prose-h3:text-gray-700 hover:prose-a:text-pushfusion"
              dangerouslySetInnerHTML={{
                __html: template(html, {
                  COMPANY_NAME,
                  COMPANY_WEBSITE,
                  INTRO,
                }),
              }}
            />
          </div>
        </Section>
      </div>
    </Layout>
  )
}

export const fileQuery = graphql`
  query PrivacyPolicyQuery {
    file(absolutePath: { regex: "/privacy-policy.md/" }) {
      childMarkdownRemark {
        html
        frontmatter {
          title
          date
          intro_products
        }
      }
    }
  }
`
